import { render, staticRenderFns } from "./PanelBottom.vue?vue&type=template&id=b4df6676&"
import script from "./PanelBottom.vue?vue&type=script&lang=ts&"
export * from "./PanelBottom.vue?vue&type=script&lang=ts&"
import style0 from "./PanelBottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports